// eslint-disable-next-line import/prefer-default-export
export const scrollToIngredientCategoryId = (ingredientCategoryId) => {
  const ingredientCategoryElement = document.querySelector(
    `#IngredientCategory-${ingredientCategoryId}`,
  );
  if (ingredientCategoryElement) {
    ingredientCategoryElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};
